import React from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter as Router } from 'react-router-dom';

import { Provider } from 'react-redux';
import { store } from './app/store';

import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { datadogRum } from '@datadog/browser-rum';

import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById('root')!;
const root = createRoot(container);

const env = cookies.get('env');
const tenantSubDomain = cookies.get('tenantSubDomain');
const apiBaseDomain = cookies.get('apiBaseDomain');
const userName = cookies.get('userName');
let sessionReplaySampleRate = 0;
if (env === 'uat' || env === 'prod') {
  sessionReplaySampleRate = 100;
}
datadogRum.init({
  applicationId: '3904e90f-67cd-441d-bae9-e97efe9ea872',
  clientToken: 'pubdf7b58a0c2767fe44429aec08fd45d8a',
  site: 'datadoghq.eu',
  service: 'creativelab-front',
  env: env,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sampleRate: 100,
  sessionReplaySampleRate: sessionReplaySampleRate,
  trackInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'allow',
  useCrossSiteSessionCookie: true,
  allowedTracingOrigins: [`https://${tenantSubDomain}.${apiBaseDomain}`],
  beforeSend: (event, context) => {
    // recueillir des en-têtes de réponse d'une ressource RUM
    // if (event.type === 'resource' && event.resource.type === 'fetch') {
    event.context = {
      ...event.context,
      tenant: tenantSubDomain,
      user: userName
    };
    // }
  }
});

datadogRum.startSessionReplayRecording();
// }

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Router>
      <IconSettings iconPath="/assets/icons">
        <App />
      </IconSettings>
    </Router>
  </Provider>
  // </React.StrictMode>
);

reportWebVitals();
